import { createContext, useContext } from 'react'
import { PotentialUserFragment } from '../../../types/graphql'

export const PotentialUserContext = createContext({
    potentialUser: undefined,
    alreadySignedUp: false,
    setPotentialUser: (potentialUser: PotentialUserFragment) => {
        console.error('Context not implemented')
    },
    setAlreadySignedUp: (signedUp: boolean) => {
        console.error('Context not implemented')
    },
})
PotentialUserContext.displayName = 'PotentialUserContext'

export const usePotentialUser = () => useContext(PotentialUserContext)
